// src/components/CoverPage/styles.js
const styles = theme => ({
  container: {
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    alignItems: 'center',
    gap: '16px',
    flexDirection: 'column',
    paddingBottom: '36px',
    marginTop: '56px',
  },
  root: {
    width: '100%',
  },
  headerText: {
    color: '#002E47',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500,
  },
})

export default styles
